module.exports = __webpack_public_path__ + "static/media/adult-analyzing.200d78fb.png";